import type { JSX } from 'react';

interface JiraIconProps {
  className?: string;
}

export function JiraIcon({ className = '' }: JiraIconProps): JSX.Element {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M11.53 2c0 2.4 1.97 4.35 4.35 4.35h1.78v1.7c0 2.4 1.94 4.34 4.34 4.35V2.84a.84.84 0 0 0-.84-.84H11.53zM6.77 6.8a4.36 4.36 0 0 0 4.34 4.34h1.8v1.72a4.36 4.36 0 0 0 4.34 4.35V7.65a.85.85 0 0 0-.85-.85H6.77zM2 11.6a4.35 4.35 0 0 0 4.34 4.34h1.8v1.72A4.35 4.35 0 0 0 12.48 22v-9.56a.85.85 0 0 0-.85-.84H2z" />
    </svg>
  );
}
